import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyBsG1-8rr0oYOTEoNyrnUWd_nBPjhZ3c9c",
  authDomain: "baitti-ios.firebaseapp.com",
  projectId: "baitti-ios",
  storageBucket: "baitti-ios.firebasestorage.app",
  messagingSenderId: "926400503117",
  appId: "1:926400503117:web:f7b89e2532662a040aeb04",
  measurementId: "G-L0LSE4KJT0"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

export { db };